import { PureLightTheme } from "../../../../styles/theme"
import { COLORS } from "../../../../styles/variables"

export const MainStack = {
    marginLeft: "76px",
    [PureLightTheme.breakpoints.down('sm')]: {
        marginLeft: "45px",
    }
}

export const AvatarStyle = {
    width: "45px", 
    height: "45px", 
    marginRight: "20px",
    [PureLightTheme.breakpoints.down('sm')]: {
        width: "25px", 
        height: "25px", 
        marginRight: '10px',
    }
}

export const TypReplies = {
    display: '-webkit-box',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    WebkitBoxOrient: 'vertical',
    WebkitLineClamp: 2,
    overflowWrap: 'anywhere',   
    "& span": {
        marginRight: 1,
    },
    "& span:first-of-type": {
        color: COLORS.CERULEAN, 
        fontSize: '14px', 
        fontWeight: 600,
    },
}